import { RootState } from '@store/rootReducer'

export const selectIsAuthenticated = (state: RootState) => state.auth.isAuthenticated
export const selectAccessToken = (state: RootState) => state.auth.accessToken
export const selectRefreshToken = (state: RootState) => state.auth.refreshToken
export const selectCurrentUser = (state: RootState) => state.auth.currentUser
export const selectSignUpError = (state: RootState) => state.auth.signUpReq.error
export const selectSignInError = (state: RootState) => state.auth.signInReq.error
export const selectMFASignInError = (state: RootState) => state.auth.mfaSignInReq.error
export const selectSignInLoading = (state: RootState) => state.auth.signInReq.loading
export const selectMFASignInLoading = (state: RootState) => state.auth.mfaSignInReq.loading
export const selectSignUpLoading = (state: RootState) => state.auth.signUpReq.loading
